import {
  TaskModel,
  TaskParameterModel,
  ITaskListingModel
} from "../models/task";

import { AxiosPromise } from "axios";
import { GenericBaseParameter } from "../models/base-parameter";
import { GenericServices } from "./generic.services";
import { taskUri } from "../common";
import { ApiResponse } from "../models/app-configuration";
import { Listing } from "../models/listing-base-model";

export class TaskServices extends GenericServices {
  // @ts-ignore
  selectPost<TValue, TResult>(
    params: GenericBaseParameter<TaskParameterModel>
  ): AxiosPromise<TResult> {
    params.Fields = "*";
    return this.executeSelectingPost(params, taskUri.search);
  }

  select<TValue, TResult>(
    params: TValue,
    path?: string
  ): AxiosPromise<TResult> {
    return this.executeSelecting(params, path);
  }
  selectAsync<TValue, TResult>(
    params: TValue,
    path?: string
  ): AxiosPromise<TResult[]> {
    return this.executeSelecting(params, path);
  }
  insertTask<TResult>(model: TaskModel): AxiosPromise<TResult> {
    return this.executeCreating(model, taskUri.default).then((response: ApiResponse) => {
      return response.isSuccess
        ? Promise.resolve(response.data)
        : Promise.reject(response)
    })
      .catch(error => Promise.reject(error));
  }

  updateTask<TResult>(
    originEntity: TaskModel,
    entity: TaskModel
  ): AxiosPromise<TResult> {
    const clonedOriginEntity = JSON.parse(JSON.stringify(originEntity));
    const clonedEntity = JSON.parse(JSON.stringify(entity));

    let path = taskUri.paramId.replace(":id", entity.Id.toString());
    return this.executeUpdatingCompare(clonedOriginEntity, clonedEntity, path).then((response: ApiResponse) => {
      return response.isSuccess
        ? Promise.resolve(response.data)
        : Promise.reject(response)
    })
      .catch(error => Promise.reject(error));
  }
  selectBy<TValue, TResult>(
    value: TValue,
    path?: string
  ): AxiosPromise<TResult> {
    return this.executeSelectBy(value, path);
  }
  deleteTask<TResult>(ids: number[]): AxiosPromise<TResult> {
    let path = taskUri.paramId.replace(":id", ids.join(","));
    return this.executeDeleting(path)
      .then((response: ApiResponse) => {
        return response.isSuccess
          ? Promise.resolve(response.data)
          : Promise.reject(response.message);
      })
      .catch(error => Promise.reject(error));
  }
  selectByAsync<TValue, TResult>(
    value: TValue,
    path?: string
  ): AxiosPromise<TResult> {
    return this.executeSelectByAsync(value, path);
  }
  getListOfTasks(param: GenericBaseParameter<TaskParameterModel>, cancelTokenSource?: any) {
    return super
      .executeSelectingPost(param, taskUri.search, cancelTokenSource)
      .then((response: ApiResponse) => {
        if (response.isSuccess) {
          return Promise.resolve(
            new Listing<ITaskListingModel>("listOfTasks", response.data)
          );
        } else return Promise.reject(response.message);
      })
      .catch(ex => {
        console.log(ex);
        return Promise.reject(ex);
      });
  }

  initTask(model: TaskModel): AxiosPromise<TaskModel> {
    return this.executeSelectingPost(model, taskUri.init);
  }


  setTouchTasks(taskIds: number[]): AxiosPromise<any> {
    let path = taskUri.touch.replace(":ids", taskIds.join(","));
    return this.executePut(null, path);
    }
    
    quickUpdateTask(id: number, payload) {
        const params = []
        Object.keys(payload).forEach(key => {
            params.push({
                op: "replace",
                path: `/${key}`,
                value: payload[key]
            })
        })
        let path = taskUri.paramId.replace(":id", id.toString());
        return this.executePatch(params, path).then((response: ApiResponse) => {
            if (response.data && response.data.isSuccess) {
                return Promise.resolve(true);
            } else return Promise.reject(response.data && response.message);
        }).catch(ex => {
            return Promise.reject(ex);
        });
    }

    updateTaskStatus(id: number, isDone: boolean) {
        const payload = [{
            op: "replace",
            path: "/IsDone",
            value: isDone
        }]
        let path = taskUri.paramId.replace(":id", id.toString());
        return this.executePatch(payload, path).then((response: ApiResponse) => {
            if (response.data && response.data.isSuccess) {
                return Promise.resolve(true);
            } else return Promise.reject(response.data && response.message);
            }).catch(ex => {
                    return Promise.reject(ex);
            });
    }

    deleteAll(payload) {
        return new Promise((resolve, reject) => {
            return super.executeDeletingWith(payload, taskUri.deleteAll)
                .then((response: ApiResponse) => {
                    return response.isSuccess ? resolve(response.data) : reject(response.message);
                }).catch(error => {
                    return reject(error)
                })
        })
    }

    createTaskEvaluation(payload) {
        return super.executeSelectingPost(payload, taskUri.createTaskEvaluation)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                } else return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

    createTaskCond(payload) {
        return super.executeSelectingPost(payload, taskUri.createTaskCondition)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                } else return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            });
    }

  constructor() {
    super();
  }
}
